import { pageNames } from '@atc/bonnet-paths';
import { stringDuckCreator } from '@atc/modular-redux';

export default stringDuckCreator({
    store: 'showInventoryDuck',
    initialState: false,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
